module.exports = __webpack_public_path__ + "img/footer-logo.83a91378.png";